import { configureStore } from '@reduxjs/toolkit'
import { setAutoFreeze } from 'immer'
import mainModeReducer from './slices/mainModeSlice'
import gameStatsReducer from './slices/gameStatsSlice'
import replaysReducer from './slices/replaysSlice'

const isHeadless = (() => {
  if (typeof window === 'undefined') return false
  try {
    const params = new URLSearchParams(window.location.search || '')
    if (params.has('hraHeadless')) return true
    const raw = window.location.search || ''
    return raw.includes('hraHeadless=')
  } catch (_) {
    return false
  }
})()

if (isHeadless) {
  try { setAutoFreeze(false) } catch (_) {}
}

export default configureStore({
  reducer: {
    mainMode: mainModeReducer,
    gameStats: gameStatsReducer,
    replays: replaysReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: !isHeadless,
    serializableCheck: !isHeadless
  }),
  devTools: !isHeadless
})
